import Cursor from '@/components/common/cusor';
import Lines from '@/components/common/Lines';
import ProgressScroll from '@/components/common/ProgressScroll';
import Footer from '@/components/home-main/Footer';
import Navbar from '@/components/home-main/Navbar';
import Challenge from '@/pages/landingpage/services-pages/project1/components/Challenge';
import Header from '@/pages/landingpage/services-pages/project1/components/Header';
import Solution from '@/pages/landingpage/services-pages/project1/components/Solution';
import Works from '@/pages/landingpage/services-pages/project1/components/Works';
import { Helmet } from 'react-helmet';

export default function Project1() {
  return (
    <>
      <Helmet>
        <title>Project1</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header title='Project 1' bgImg='https://www.bbva.com/wp-content/uploads/2020/12/blockchain-1024x629.jpg'/>
              <Challenge />
              <Works />
              <Solution />
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
